var map = {
	"./404.svg": 6856,
	"./add.svg": 5593,
	"./auction.svg": 1841,
	"./back.svg": 5601,
	"./beauty.svg": 4566,
	"./book.svg": 919,
	"./car.svg": 3485,
	"./cashgift.svg": 3780,
	"./catering.svg": 7891,
	"./child.svg": 8400,
	"./cigarette_wine.svg": 2066,
	"./clear.svg": 6278,
	"./communication.svg": 5964,
	"./costume.svg": 6723,
	"./dayuse.svg": 2936,
	"./delete.svg": 4718,
	"./detail.svg": 8602,
	"./digital.svg": 3178,
	"./fruits.svg": 3134,
	"./furniture.svg": 5490,
	"./gift.svg": 1581,
	"./house.svg": 7871,
	"./licai.svg": 5972,
	"./lottery.svg": 8875,
	"./maintain.svg": 3573,
	"./medical.svg": 6031,
	"./movie.svg": 3716,
	"./oldman.svg": 8590,
	"./otherrevenue.svg": 9227,
	"./parttime.svg": 4843,
	"./pet.svg": 8407,
	"./recreation.svg": 9701,
	"./remake.svg": 1750,
	"./setting.svg": 5426,
	"./shopping.svg": 6082,
	"./snacks.svg": 4297,
	"./social_contact.svg": 2576,
	"./sport.svg": 741,
	"./statistics.svg": 8821,
	"./study.svg": 9931,
	"./traffic.svg": 7621,
	"./transfer_accounts.svg": 6410,
	"./travel.svg": 8469,
	"./vegetable.svg": 2769,
	"./wage.svg": 926,
	"./work.svg": 8385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8074;